<template>
  <div>
    <NuxtLink :href="linkTo(titleEntity)">
      <div class="aspect-[5/7] flex mb-2 relative hover-scale overflow-hidden">
        <AsyncImage class="rounded-md object-cover flex-grow" :src="coverUrl" />
        <!--        <span-->
        <!--          class="text-xs sm:text-base absolute bottom-2 left-2 bg-neutral-200/80 dark:bg-neutral-900/80 px-1 sm:px-2 rounded shadow backdrop-blur"-->
        <!--          >{{-->
        <!--            $t(-->
        <!--              `entity.title.follow.reading_status.${followsEntity.attributes.readingStatus}`,-->
        <!--            )-->
        <!--          }}</span-->
        <!--        >-->
        <div
          class="absolute bottom-2 right-2 w-8 h-8 flex items-center justify-center rounded-full drama-black drama-2 backdrop-blur"
          :class="{
            'bg-neutral-200/80 dark:bg-neutral-900/80':
              !followsEntity.attributes.notification,
            'bg-nami-comi-blue/80 text-white':
              followsEntity.attributes.notification,
          }"
        >
          <IconBellRinging
            class="inline-block"
            v-if="followsEntity.attributes.notification"
            :size="20"
          />
          <IconBellOff class="inline-block" v-else :size="20" />
        </div>
      </div>
    </NuxtLink>
    <h3 class="line-clamp-2">{{ title }}</h3>
  </div>
</template>

<script setup lang="ts">
import type { TitleEntity, TitleFollowsEntity } from "~/src/api";
import { IconBellRinging, IconBellOff } from "@tabler/icons-vue";

const props = defineProps<{
  titleEntity: TitleEntity;
  followsEntity: TitleFollowsEntity;
}>();

const { coverUrl, title } = parseTitleForDisplay(
  computed(() => props.titleEntity),
  "med",
);
</script>

<style scoped lang="postcss"></style>
